import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const ColorDot = styled(Box)(() => ({
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  cursor: 'pointer',
}));

export const FlaggedCheckText = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '19.12px',
  letterSpacing: '0.14px',
  color: '#000000',
  marginRight: 5,
}));
